import { fetchSnap } from '../common/utils';

import SnapCardRenderer from '../common/snap-card-renderer';
const snapCardRenderer = SnapCardRenderer();

import ModalSnap from '../sections/modal-2023-snap';
const modalSnap = ModalSnap();

const initializePageSnap = (mediaGridSections, paginationSection, page) => {
  const nDisplay = mediaGridSections.reduce((sum, mgs) => sum + mgs.limit, 0);
  if (nDisplay <= 0) {
    return;
  }

  fetchSnap({ limit: 99999 }).then((results) => {
    if (!window.fstore.mediaCache) {
      window.fstore.mediaCache = {};
    }
    if (!window.fstore.mediaCache.snaps) {
      window.fstore.mediaCache.snaps = [];
    }
    window.fstore.mediaCache.snaps = window.fstore.mediaCache.snaps.concat(results);

    let displayOffset = (page - 1) * nDisplay;
    mediaGridSections.forEach((mediaGridSection, i) => {
      const snaps = results.slice(displayOffset, displayOffset + mediaGridSection.limit);
      renderMediaGrid(mediaGridSection, snaps);
      displayOffset += mediaGridSection.limit;
    });

    const nPages = Math.max(1, Math.ceil(results.length / nDisplay));
    renderPagination(paginationSection, page, nPages);
  });
};

const renderMediaGrid = (mediaGridSection, snaps) => {
  const sectionElement = document.querySelector(`#shopify-section-${mediaGridSection.id}`);
  if (snaps.length <= 0) {
    sectionElement.style.display = 'none';
    return;
  }
  const items = snaps.map((snap) => {
    const item = snapCardRenderer.renderSnap(snap);
    return `<div class="fs-media-grid-item">${item}</div>`;
  });
  if (0 < snaps.length % 4) {
    for (let i = 0; i < 4 - (snaps.length % 4); i++) {
      items.push(`<div class="fs-media-grid-item"></div>`);
    }
  }
  const itemsElement = sectionElement.querySelector('.fs-media-grid-items');
  itemsElement.innerHTML = items.join('');

  itemsElement.querySelectorAll('.fs-snap-card a').forEach((a) => {
    a.addEventListener('click', (e) => {
      e.preventDefault();
      modalSnap.showModalSnap(a.dataset['articleId']);
    });
  });
};

const renderPagination = (paginationSection, page, nPages) => {
  const sectionElement = document.querySelector(`#shopify-section-${paginationSection.id}`);
  if (nPages <= 1) {
    sectionElement.style.display = 'none';
    return;
  }

  const min = Math.max(1, page - 4);
  const max = Math.min(nPages, min + 9);
  const minSP = Math.max(1, page - 1);
  const maxSP = Math.min(nPages, minSP + 2);

  const url = new URL(window.location.href);
  const items = [];

  if (page > 1) {
    url.searchParams.set('page', page - 1);
    items.push(`
      <li>
        <a href="${url.toString()}" data-page="${page - 1}" class="pagination__item link pagination__item--next pagination__item-arrow">
          <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.0898438 10.58L4.66984 6L0.0898438 1.41L1.49984 0L7.49984 6L1.49984 12L0.0898438 10.58Z" fill="#101319"></path>
          </svg>
        </a>
      </li>
    `);
  } else {
    items.push(`
      <li>
        <span class="pagination__item pagination__item--next pagination__item-arrow">
          <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.0898438 10.58L4.66984 6L0.0898438 1.41L1.49984 0L7.49984 6L1.49984 12L0.0898438 10.58Z" fill="#101319"></path>
          </svg>
        </span>
      </li>
    `);
  }

  for (let i = min; i <= max; i++) {
    if (i == page) {
      items.push(`<li><span class="pagination__item pagination__item--current">${i}</span></li>`);
    } else {
      let visibleSP = i >= minSP && i <= maxSP;
      url.searchParams.set('page', i);
      items.push(
        `<li class="${visibleSP ? '' : 'pc'}"><a href="${url.toString()}" data-page="${i}" class="pagination__item link">${i}</a></li>`,
      );
    }
  }

  if (page < nPages) {
    url.searchParams.set('page', page + 1);
    items.push(`
      <li>
        <a href="${url.toString()}" data-page="${page + 1}" class="pagination__item link pagination__item--prev pagination__item-arrow">
          <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.0898438 10.58L4.66984 6L0.0898438 1.41L1.49984 0L7.49984 6L1.49984 12L0.0898438 10.58Z" fill="#101319"></path>
          </svg>
        </a>
      </li>
    `);
  } else {
    items.push(`
      <li>
        <span class="pagination__item pagination__item--prev pagination__item-arrow">
          <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.0898438 10.58L4.66984 6L0.0898438 1.41L1.49984 0L7.49984 6L1.49984 12L0.0898438 10.58Z" fill="#101319"></path>
          </svg>
        </span>
      </li>
    `);
  }

  sectionElement.querySelector('.pagination-wrapper .pagination__list').innerHTML = items.join('');
  sectionElement.querySelector('.pagination-wrapper').classList.remove('hidden');
};

/*
 * Main
 */

const pageSnapMain = () => {
  if (!location.pathname.startsWith('/pages/snap')) {
    return;
  }
  if (!window.fstore.sections) {
    return;
  }
  const mediaGridSections = window.fstore.sections.filter((section) => section.sectionType == 'media-grid-snaps');
  if (mediaGridSections.length <= 0) {
    return;
  }
  const paginationSection = window.fstore.sections.filter((section) => section.sectionType == 'pagination')[0];
  const params = new URLSearchParams(window.location.search);
  const page = parseInt(params.get('page') || 1);
  initializePageSnap(mediaGridSections, paginationSection, page);
};

addEventListener('DOMContentLoaded', () => {
  pageSnapMain();
});
